module.exports = __webpack_public_path__ + "img/IdrisAli-DaykaSozaniyakam.de098654.jpg";